<template>
  <div class="modal-window bds073">
    <div class="modal-header">
      <div class="tit">{{projectId != null ? $i18nUtil.trans("title.RegistBoardModal.001","과제 보드 추가") : $i18nUtil.trans("title.RegistBoardModal.002","프라이빗 보드 추가")}}</div>
      <button class="btn_close" @click="closeRegistBoardModal()">닫기</button>
    </div>

    <div class="modal-content">
      <div class="top">
        <!-- shareType : {{shareType}} -->
        <!-- <div v-if="shareType == null">{{projectId != null ? projectName : "프라이빗"}}</div> -->

        <div class="tooltip-b tl small" :style="{'z-index': tooltip.zIndex, 'display': tooltip.display, 'bottom': tooltip.bottom, 'width': tooltip.width, 'left': tooltip.left}" style="position: absolute">
          {{ tooltipCategoryName == null ? "" : tooltipCategoryName }}
        </div>

        <div class="dropdown ty1 relative only only-other">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="ell-singleline">
                {{categoryName}}
              </v-btn>
            </template>
            <div class="dropdown-list" style="min-width: 740px;">
              <div class="scroll">
                <div 
                  class="dropdown-list-item" 
                  v-for="(item, index) in categoryItems"
                  :value="item.categoryMid"
                  :key="index"
                  @click="changeCategory(item, index)"
                >
                  <div class="tit">
                    <button
                      type="button" class="ell-singleline"
                      :class="categoryItem != null ? (item.categoryMid == categoryItem ? 'active' : '') : (index == 0 ? 'active' : '')"
                      @mouseover="mouseEvt(true, item.categoryName, $event)"
                      @mouseleave="mouseEvt(false, null, $event)"
                    >
                      {{ item.categoryName }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-menu>
        </div>

        <!-- 보드등급설정 --> 
        <!-- <span v-if="docGrade == 'SECRET'">
          비공개
        </span> -->
        <div class="dropdown ty1 relative" v-if="docGrade != 'SECRET'">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">
                {{
                  changedDocGrade == "NORMAL"
                    ? $i18nUtil.trans("entity.paper.docGrade.NORMAL","전체공개")
                    : changedDocGrade == "RESTRICT"
                    ? $i18nUtil.trans("entity.paper.docGrade.RESTRICT","멤버만 공개")
                    : $i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")
                }}
              </v-btn>
            </template>
            <div class="scroll">
              <div class="dropdown-list">
                <div class="dropdown-list-item" v-if="docGrade == 'NORMAL'">
                  <div class="tit">
                    <button
                      type="button"
                      :class="changedDocGrade === 'NORMAL' ? 'active' : ''"
                      @click="changeDocGrade('NORMAL')"
                    >
                      {{ $i18nUtil.trans("entity.paper.docGrade.NORMAL","전체공개") }}
                    </button>
                  </div>
                </div>

                <div class="dropdown-list-item" v-if="docGrade == 'NORMAL' || docGrade == 'RESTRICT'">
                  <div class="tit">
                    <button
                      type="button"
                      :class="changedDocGrade === 'RESTRICT' ? 'active' : ''"
                      @click="changeDocGrade('RESTRICT')"
                    >
                      {{ $i18nUtil.trans("entity.paper.docGrade.RESTRICT","멤버만 공개") }}
                    </button>
                  </div>
                </div>

                <div class="dropdown-list-item">
                  <div class="tit">
                    <button
                      type="button"
                      :class="changedDocGrade === 'SECRET' ? 'active' : ''"
                      @click="changeDocGrade('SECRET')"
                    >
                      {{ $i18nUtil.trans("entity.paper.docGrade.SECRET","비공개") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </v-menu>
        </div>
        
      </div> 

      <div class="input-box tit">
          <!-- placeholder="보드의 제목을 입력해주세요."  -->
          <input 
            type="text" 
            required 
            @focus="$event.target.placeholder = ''"
            @focusout="$event.target.placeholder = $i18nUtil.trans('message.RegistBoardModal.001','보드의 제목을 입력해주세요.')"
            :placeholder="$i18nUtil.trans('message.RegistBoardModal.001','보드의 제목을 입력해주세요.')"
            v-model="paperTitle" 
            @input="displayBytes(maxBytes, paperTitle, $event)"
            @keyup.enter="onClickSubmit"
          >
            <!-- @input="paperTitle = $event.target.value" -->
          <!-- <div class="error" v-if="error">입력 가능한 글자수를 초과하였습니다. <span>({{checkBytes + `/` + maxBytes + `bytes`}})</span></div> -->
          <div class="error" v-if="error">{{$i18nUtil.trans('UB008', {textLength: paperTitle == null ? 0 : paperTitle.length, byteLength: checkBytes, maxByteLength: maxBytes})}}</div>
          <div class="error" v-if="titleError">{{$i18nUtil.trans('UB011')}}</div>
      </div>
      <div class="editor textarea" style="overflow-y: auto; width: 100%; height: 124px !important; resize: none;">
        <!-- editor bubble bar 영역 -->
        <editor-menu-bubble
          :editor="registEditor"
          :keep-in-bounds="keepInBounds"
          v-slot="{ commands, isActive, menu }"
        >
          <div
            class="menububble"
            :class="{ 'is-active': menu.isActive }"
            :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
          >
            <button
              class="menububble-button h2"
              :class="{ 'is-active': isActive.heading({ level: 2 }) }"
              @click="commands.heading({ level: 2 })"
            >H2</button>
            <button
              class="menububble-button h3"
              :class="{ 'is-active': isActive.heading({ level: 3 }) }"
              @click="commands.heading({ level: 3 })"
            >H3</button>

            <button
              class="menububble-button b"
              :class="{ 'is-active': isActive.bold() }"
              @click="commands.bold"
            ><i class="fa fa-bold" aria-hidden="true"></i></button>

            <button
              class="menububble-button i"
              :class="{ 'is-active': isActive.italic() }"
              @click="commands.italic"
            ><i class="fa fa-italic" aria-hidden="true"></i></button>

            <button
              class="menububble-button strikethrough"
              :class="{ 'is-active': isActive.strike() }"
              @click="commands.strike"
            ><i class="fa fa-strikethrough" aria-hidden="true"></i></button>

            <button
              class="menububble-button underline"
              :class="{ 'is-active': isActive.underline() }"
              @click="commands.underline"
            ><i class="fa fa-underline" aria-hidden="true"></i></button>
            
            <component
              :is="initSwatches"
              v-model="vcolor"
              :swatches="vswatches"
              row-length="4"
              shapes="squares"
              show-border
              popover-x="right">
              <button slot="trigger" :value="vcolor"
                class="menububble-button swatches"
                :class="{ 'is-active': isActive.span_element({ color: vcolor }) }"
                @input="vcolor">
                <i class="fa fa-eyedropper" aria-hidden="true"></i>
              </button>
            </component>

            <!--custom alignment -->
            <button
              class="menububble-button left"
              :class="{ 'is-active': isActive.paragraph({textAlign: 'left'}) }"
              @click="commands.paragraph({textAlign:'left'})"
            ><i class="fa fa-align-left" aria-hidden="true"></i></button>

            <button
              class="menububble-button center"
              :class="{ 'is-active': isActive.paragraph({textAlign: 'center'}) }"
              @click="commands.paragraph({textAlign:'center'})"
            ><i class="fa fa-align-center" aria-hidden="true"></i></button>

            <button
              class="menububble-button right"
              :class="{ 'is-active': isActive.paragraph({textAlign: 'right'}) }"
              @click="commands.paragraph({textAlign:'right'})"
            ><i class="fa fa-align-right" aria-hidden="true"></i></button>

            <button
              class="menububble-button justify"
              :class="{ 'is-active': isActive.paragraph({textAlign: 'justify'}) }"
              @click="commands.paragraph({textAlign:'justify'})"
            ><i class="fa fa-align-justify" aria-hidden="true"></i></button>
          </div>
        </editor-menu-bubble>
        <editor-content class="editor__content" style="height: 100%" :editor="registEditor" />
      </div>
      <!-- <textarea name="" id="contentPath" placeholder="클릭하여 내용을 입력하세요." v-model="contentPath"></textarea> -->
    
      <div class="tag_pop" v-if="boardHashTagUse">
        <button type="button" class="btn_link_add" @click="setTags">{{ $i18nUtil.trans("message.RegistBoardModal.003","태그설정") }}</button>
        <span class="error" :class="tagError ? '':'tagErrorColor'"> {{ $i18nUtil.trans("message.RegistBoardModal.004","태그를 설정해주세요.") }}</span>
        <div class="tag_wrap">
          <div class="tag_inner">
            <div v-for="(tag, idx) in selectedTags" :key="'selectedTag_'+idx">#{{tag.htag}}</div>
          </div>
        </div>
      </div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="onClickSubmit">{{ $i18nUtil.trans("button.RegistBoardModal.save","저장") }}</button>
    </footer>

    <!-- <modals-container @returnSelectedTags="returnSelectedTags"/> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Editor, EditorContent, EditorMenuBubble } from "tiptap";
import {
  Placeholder,
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from "tiptap-extensions";
import RegistBoardContent from "@/components/cowork/general/board/modal/RegistBoardContent";
import { Schema, DOMParser, DOMSerializer } from "prosemirror-model";
import SpanElement from "@/components/cowork/general/board/extensions/SpanElement";
import Paragraph from "@/components/cowork/general/board/extensions/Paragraph";
/* 보드 유틸 */
import BoardUtil from "../base/BoardUtil.js";
/* 태그 설정 */
import setTagsModal from "./SetTagsModal";
import EventBus from "@/js/eventbus/eventBus";
import Vue from 'vue';

export default {
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  components: {
    EditorContent,
    EditorMenuBubble,
    SpanElement,
    Paragraph,
    RegistBoardContent,
  },
  created() {
    // this.createdList();
    EventBus.$off("returnSelectedTags");
    EventBus.$on("returnSelectedTags", (param) => {
      if(param.tagList.length != 0){
        this.toastInfo.message = this.$i18nUtil.trans("TB101");
        this.showToast(this.toastInfo);
        this.tagError = false;
        this.selectedTags = param.tagList;
        this.selectedJobGroup = param.selectedJobGroup;
      }else{
        this.tagError = true;
      }
    });
  },
  data() {
    return {
      paperTitle: this.$props.modalInfo.paperTitle,
      contentPath: this.$props.modalInfo.contentPath,
      paperId: this.$props.modalInfo.paperId,
      categoryMid: this.$props.modalInfo.categoryMid,
      groupId: this.$props.modalInfo.groupId,
      projectId: this.$props.modalInfo.projectId,
      projectName: this.$props.modalInfo.projectName,
      shareType: this.$props.modalInfo.shareType,
      // parentCategoryItem : this.$props.modalInfo.parentCategoryMid || null,
      categoryItem: this.$props.modalInfo.categoryMid || null,
      categoryName: null,
      docGrade: this.$props.modalInfo.docGrade || 'NORMAL',
      changedDocGrade: this.$props.modalInfo.docGrade || 'NORMAL',
      firstEvent: true,
      keepInBounds: true,
      boardUtil: BoardUtil,
      initSwatches: null,
      vcolor: BoardUtil.colors[0],
      vswatches: BoardUtil.colors,
      categoryItems: [],
      // parentCategoryItems : [],
      parentCategoryGroupId: this.$props.modalInfo.groupId,
      parentCategoryName: null,
      error: false,
      titleError: false,
      checkBytes: 0,
      maxBytes: 60,
      // registJSON: '',
      // registHTML: '',
      registEditor: null,
      toastInfo: {
          obj: this.$toasted,
          message: "",
          options: {
            theme: "toasted-primary",
            position: "bottom-left",
            duration: 3000,
          },
      },

      announcementUseYn : localStorage.getItem("announcementUseYn") === "true" ? true : false,
      
      /* Tag */
      boardHashTagUse: localStorage.getItem("boardHashTagUse") === "true" ? true : false,
      selectedTags : [],
      selectedJobGroup: null,
      tagError: false,

      /* tooltip */
      hover: false,
      tooltipFlag: false,
      tooltipCategoryName: null,
      tooltip: {
        zIndex: 0,
        display: 'none',
        bottom: '0px',
        width: '0px',
        left: '30px'
      }
    };
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast", "showModal"]),

    mouseEvt(flag, categoryName, event) {
      this.hover = flag;
      this.tooltipCategoryName = categoryName
      // let val = this.$tooltip.checkTabLength(categoryName, 100)
      
      let val = this.$tooltip.hasOverflownModalSelectBox(event.target); // modalInfo.name == 'RegistShareInfoBoard' ? 
      this.tooltipFlag = this.hover == true && val == true ? true : false
      this.activateTooltip(this.tooltipFlag, event);
    },
    activateTooltip(val, event) {
      let modalStyle = document.getElementsByClassName("v--modal-box")[0].getBoundingClientRect() // 모달의 style 정보;
      let loc = event.target.getBoundingClientRect().top; // 마우스 오버 타겟의 top
      loc = Math.abs(loc - modalStyle.bottom);
      // console.log("################ > ", loc);
      let width = event.target.getBoundingClientRect().width;

      if(val) {
        this.tooltip.zIndex = 13;
        this.tooltip.display = "inline-block";
        this.tooltip.width = width+'px';
        this.tooltip.bottom = loc+'px';
      }else{
        this.tooltip.zIndex = 0;
        this.tooltip.display = "none";
        this.tooltip.width = '0px';
        this.tooltip.bottom = '0px';
      }
    },
    initCategoryItems() {
      if(this.shareType !== null && this.shareType !== undefined) {
        let obj = this;
        let reqData = {};
        reqData.req = obj.req;
        reqData.url = "/api/copaper/category/getCategoryItemList";
        reqData.method = "post";
        reqData.params = {
          categoryMid: null,
          groupId: this.groupId,
          type: this.modalInfo.shareType,
        };
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            obj.categoryItems = res.result;
            if(obj.categoryItem != null) {
              if(obj.categoryItems.length > 0) {
                obj.categoryItems.forEach(item => {
                  if(item.categoryMid == obj.categoryItem) {
                    obj.categoryName = item.categoryName;
                  }
                });
              }
            }
            if (!obj.categoryItem && obj.categoryItems.length > 0) {
              obj.categoryItem = obj.categoryItems[0].categoryMid;
              obj.categoryName = obj.categoryItems[0].categoryName;
            }
            obj.parentCategoryGroupId = obj.groupId;
          })
          .catch(function (err) {
            console.log(err);
          });
      }
      else if (this.groupId === null) {
        let obj = this;
        let reqData = {};
        reqData.req = obj.req;
        reqData.url = "/api/copaper/category/getCategoryItemList";
        reqData.method = "post";
        reqData.params = {
          categoryMid: null,
          groupId: null,
          type: "PERSONAL",
        };
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            obj.categoryItems = res.result;
            if(obj.categoryItem != null) {
              if(obj.categoryItems.length > 0) {
                obj.categoryItems.forEach(item => {
                  if(item.categoryMid == obj.categoryItem) {
                    obj.categoryName = item.categoryName;
                  }
                });
              }
            }
            if (obj.categoryItem == null) {
              obj.categoryItem = obj.categoryItems[0].categoryMid;
              obj.categoryName = obj.categoryItems[0].categoryName;
            }
            obj.parentCategoryGroupId = obj.groupId;
          })
          .catch(function (err) {
            console.log(err);
          });
      } else if (this.groupId !== null) {
        let type = "GROUP";
        if (this.projectId !== null) {
          type = "PROJECT";
        }
        let obj = this;
        let reqData = {};
        reqData.req = obj.req;
        reqData.url = "/api/copaper/category/getCategoryItemList";
        reqData.method = "post";
        reqData.params = {
          categoryMid: null,
          groupId: this.groupId,
          type: type,
        };
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            obj.categoryItems = res.result;
            if(obj.categoryItem != null) {
              if(obj.categoryItems.length > 0) {
                obj.categoryItems.forEach(item => {
                  if(item.categoryMid == obj.categoryItem) {
                    obj.categoryName = item.categoryName;
                  }
                });
              }
            }
            if (obj.categoryItem == null) {
              obj.categoryItem = obj.categoryItems[0].categoryMid;
              obj.categoryName = obj.categoryItems[0].categoryName;
            }
            obj.parentCategoryGroupId = obj.groupId;
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },
    onChangeParentCategory(event) {
      let obj = this;
      let reqData = {};
      reqData.req = obj.req;
      reqData.url = "/api/copaper/category/getCategoryItemList";
      reqData.method = "post";
      reqData.params = {
        categoryMid: this.parentCategoryItem,
        groupId: this.parentCategoryGroupId,
      };
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          obj.categoryItems = res.result;
          if (
            obj.categoryItems.length > 0 &&
            this.categoryItem != null &&
            this.firstEvent
          ) {
            this.firstEvent = false;
          } else if (
            obj.categoryItems.length > 0 &&
            this.categoryItem != null &&
            !this.firstEvent
          ) {
            obj.categoryItem = obj.categoryItems[0].categoryMid;
            obj.categoryName = obj.categoryItems[0].categoryName;
          } else if (
            obj.categoryItems.length > 0 &&
            this.categoryItem == null
          ) {
            this.firstEvent = false;
            obj.categoryItem = obj.categoryItems[0].categoryMid;
            obj.categoryName = obj.categoryItems[0].categoryName;
          }

          if (obj.groupId !== null && event !== undefined) {
            obj.parentCategoryName = event.target.selectedOptions[0].text;
            // if(event.target.selectedOptions[0].text === "Execution") {

            // }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    changeCategory(item, index) {
      this.categoryItem = item.categoryMid;
      this.categoryMid = item.categoryMid;
      this.categoryName = item.categoryName;
      this.groupId = item.groupId;
      this.etcMore("dtCategory");
    },
    etcMore(targetId) {
      if(document.getElementById(targetId)) {
        document.getElementById(targetId).classList.toggle("active");
      }
    },
    onClickSubmit() {
      if(this.error) {
        return;
      }
      if(this.paperTitle == null || this.paperTitle == undefined || this.paperTitle.length == 0) {
        this.titleError = true;
        return;
      } else {
        this.titleError = false;
      }

      if(this.boardHashTagUse){
        if(this.tagError || this.selectedTags.length == 0){
          this.tagError = true;
          return;
        }
      }
      let allData = this.registEditor.view.state.doc.content.content;

      let contentHTML = "";
      allData.forEach((element, _ind) => {
          const div = document.createElement("div");
          let _f = DOMSerializer.fromSchema(
            this.registEditor.view.state.schema
          ).serializeNode(element);
          div.appendChild(_f);
          contentHTML += div.innerHTML;
          div.removeChild(_f);
      });
      // 본문
      this.contentPath = contentHTML;
      let checkText =  this.contentPath.replace(/<(\/)?([a-zA-Z1-9]*)(\s[a-zA-Z1-9]*=[^>]*)?(\s)*(\/)?>/g,"");
      if(this.announcementUseYn && checkText==""){
        this.contentPath = null;
      }
      this.categoryMid = this.categoryItem;
      if (!this.categoryMid) {
        this.showAlertDialog(this.$i18nUtil.trans("UB012"));
        return;
      }
      // 보드가 저장되었습니다.
      // this.toastInfo.message = this.$i18nUtil.trans("TB036");
      // this.showToast(this.toastInfo);
      this.$emit("registBoard", {
        paperTitle: this.paperTitle,
        contentPath: this.contentPath,
        paperId: this.paperId,
        categoryMid: this.categoryMid,
        groupId: this.parentCategoryGroupId,
        docGrade: this.changedDocGrade,
        tagList: this.selectedTags
      });
      this.closePopup();
    },
    initEditor() {
      let obj = this;
      obj.registEditor = new Editor({
        // autoFocus ie error [prosemirror-view] focus() prevent IE scroll
        autoFocus: false,
        editable: true,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          // content
          new RegistBoardContent(),
          new Placeholder({
            emptyNodeText: (node) => {
              // console.log('contentpath', obj.registEditor);
              // if(obj.contentPath == null || obj.contentPath == "" || obj.contentPath.length == 0) {
                return obj.$i18nUtil.trans("message.RegistBoardModal.005","클릭하여 내용을 입력하세요.")
              // }
            }
          }),
          new SpanElement(),
          new Paragraph(),
          // new Alignment(),
        ],
      });
    },
    closePopup() {
      let body = document.querySelector("body");
      body.style.removeProperty("overflow");
      this.$emit("close");
    },
    closeRegistBoardModal() {
      let obj = this;
      obj.toastInfo.message = obj.$i18nUtil.trans("TB035");
      obj.showToast(obj.toastInfo);
      
      this.closePopup();
    },
    /* byte 체크 */
    displayBytes(byteLength, paperTitle, _event) {
        let obj = this;
        paperTitle = _event.target.value;
        obj.paperTitle = paperTitle;
        let checkBytes = obj.getComByteLength(obj.paperTitle);
        obj.checkBytes = checkBytes;
        obj.error = false;
        if(checkBytes > byteLength) {
          obj.error = true;
        }
        if(checkBytes > 0) {
          obj.titleError = false;
        }
    },
    changeDocGrade(_value) {
      let obj = this;
      if (_value == "NORMAL") {
        obj.showAlertDialog(
          obj.$i18nUtil.trans("TB037"), obj.$i18nUtil.trans("title.dialog.notice","알림"), {width: "520px"}, obj.$i18nUtil.trans("button.dialog.confirm","확인"), 
          function(){
            obj.changedDocGrade = _value;},
        );
      } else if (_value == "RESTRICT") {
        obj.showAlertDialog(
          obj.$i18nUtil.trans("TB038"), obj.$i18nUtil.trans("title.dialog.notice","알림"), {width: "520px"}, obj.$i18nUtil.trans("button.dialog.confirm","확인"), 
          function(){
            obj.changedDocGrade = _value;},
        );
      }
      else if (_value == "SECRET") {
        obj.showAlertDialog(
          obj.$i18nUtil.trans("AB066"), obj.$i18nUtil.trans("title.dialog.notice","알림"), {width: "520px"}, obj.$i18nUtil.trans("button.dialog.confirm","확인"), 
          function(){
            obj.changedDocGrade = _value;},
        );
      }
    },
    setTags(){
      const modalInfo = {
        title: this.$i18nUtil.trans("title.SetTagsModal.001","태그설정"),
        obj: this.$modal,
        tagList : this.selectedTags,
        selectedJobGroup : this.selectedJobGroup,
        component: setTagsModal,
      };
      this.showModal(modalInfo);
    },
  },
  mounted() {
    this.initEditor();
    this.initCategoryItems();
    // 화면 진입시 IE에서 error가 노출되고 있음.
    this.$nextTick(function() {
      this.error = false;
      this.titleError = false;
      this.initSwatches = Vue.component('vue-swatches', require('vue-swatches'));
    });
  },
  watch: {
    vcolor() {
      this.registEditor.commands.span_element({ color: this.vcolor });
    },
  },
  beforeDestroy() {
    if (this.registEditor) {
      this.registEditor.destroy();
    }
  },
};
</script>
<style scoped>
p.is-empty:nth-child(1)::before {
  content: attr(data-empty-text);
  float: left;

  color: #aaa;
  pointer-events: none;
  height: 0;
  font-style: italic;
}

.modal-content .textarea {
	width: 100%; height: 140px;	line-height:1.43;
	font-family: 'LifeplusL'; font-size:14px;	color:#000; 
  border:1px solid #acacac;
}
.ProseMirror > p {
  padding-left: 2px;
  padding-right: 2px;
}

.tagErrorColor { 
  color : #9e9e9e;
}

.tooltip-b.tl::before, .tooltip-w.tl::before {
  top: auto;
  bottom: -6px;
  -webkit-transform: rotate(
    180deg
  );
  transform: rotate(
    180deg
    );
}
.bds073 .tab-content .dropdown.ty2 .dropdown-list > .scroll > div:nth-child(2) > .tit > .tooltip-b::before {
    top: auto; bottom: -8px;
    transform: rotate(180deg);
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/RegistBoardModal.vue